import React from "react";
import PropTypes from "prop-types";
import "../style.scss";
import { makeStyles } from "@material-ui/core/styles";
import { isError, isMessageError } from "App/utils/validation";
import InputFieldOption from "./InputFieldOption";

const useStyles = makeStyles({
  error: {
    color: "red",
    fontSize: "10px",
    marginTop: "5px",
    marginLeft: "2px",
  },
  row: {
    display: "flex",
    alignItems: "center",
  },
});

export default function InputOptionMaster(props) {
  const {
    id,
    label,
    name,
    className,
    data,
    error,
    children,
    message,
    value,
    onChange,
    isRow = false,
    ...other
  } = props;

  const classes = useStyles();

  return (
    <div className={`form-group ${isRow ? classes.row : ""}`}>
      <label
        className={`form-control-label ${isRow ? "row" : ""}`}
        htmlFor={id}
        {...other}
      >
        {label}
      </label>
      <InputFieldOption {...props} />
      {isError(error) && (
        <p className={classes.error}> {isMessageError(message)} </p>
      )}
      {children}
    </div>
  );
}

InputOptionMaster.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  error: PropTypes.bool,
  message: PropTypes.string,
};
